import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import UploadForm from '../components/UploadForm';
import { useAuth } from '../contexts/AuthContext';
import Guestbook from '../components/Guestbook';
import '../wedding.css';
import {
  getWeddingByCode,
  getAllPhotos,
  deletePhotoById,
  bulkDeletePhotos,
  togglePhotoFavorite,
  applyAIEnhance,
  applyAIArtisticFilter
} from '../services/apiService';

// --- İKONLAR ---
const HeartIcon = ({ filled }) => (
  <svg viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

const DownloadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" x2="12" y1="15" y2="3" />
  </svg>
);

const TrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 6h18" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" /><path d="M10 11v6" /><path d="M14 11v6" /><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
);

// ✅ YENİ: Kamera İkonu (Kapak fotoğrafı değiştirme için)
const CameraIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
    <circle cx="12" cy="13" r="4"></circle>
  </svg>
);

const PlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="rgba(255,255,255,0.9)" stroke="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="5 3 19 12 5 21 5 3"></polygon>
  </svg>
);

const ChevronLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const ChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const MAX_SELECT = 20;
const API_BASE = (process.env.REACT_APP_API_URL || `${window.location.protocol}//${window.location.host}`).replace(/\/+$/, '');

const getThumbnailUrl = (originalUrl, width = 400) => {
  if (!originalUrl) return '';
  try {
    const url = new URL(originalUrl);
    // 'w' parametresi ile sunucudan optimize edilmiş bir resim isteyelim
    url.searchParams.set('w', width);
    return url.toString();
  } catch (e) {
    // console.warn("Invalid photo URL for thumbnailing:", originalUrl);
    return originalUrl; // Hata durumunda orijinal URL'yi döndür
  }
};

const getFilename = (res, fallback) => {
  const cd = res.headers.get('content-disposition') || '';
  const m = cd.match(/filename\*?=(?:UTF-8'')?("?)([^";]+)\1/i);
  return m ? decodeURIComponent(m[2]) : fallback;
};

export default function WeddingPage() {
  const { code } = useParams();
  const { user, logout } = useAuth();

  const isOwner = useMemo(() => {
    const primaryCode = localStorage.getItem('ownerPrimaryCode');
    const isDemo = code && code.startsWith('demo-');
    return isDemo || (!!user && primaryCode === code);
  }, [user, code]);

  const [weddingId, setWeddingId] = useState(null);
  const [weddingInfo, setWeddingInfo] = useState(null);
  const [resolving, setResolving] = useState(true);
  const [resolveError, setResolveError] = useState('');

  const [photos, setPhotos] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPhotos, setTotalPhotos] = useState(0);

  const [isGuestbookOpen, setIsGuestbookOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [orientations, setOrientations] = useState({});
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [selectedMap, setSelectedMap] = useState({});
  const [selectMode, setSelectMode] = useState(false);

  const [showFavoritesOnly, setShowFavoritesOnly] = useState(false);
  const [activeAlbumFilter, setActiveAlbumFilter] = useState('Tümü');

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activePhoto, setActivePhoto] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const dragStartRef = useRef({ x: 0, y: 0 });
  const imgBoxRef = useRef(null);

  const longPressTimerRef = useRef(null);
  const longPressTriggeredRef = useRef(false);

  const getPageConfig = (width) => {
    if (width < 600) return { rows: 3, colsPortrait: 2, colsLandscape: 2 };
    if (width < 900) return { rows: 4, colsPortrait: 3, colsLandscape: 3 };
    if (width < 1200) return { rows: 5, colsPortrait: 4, colsLandscape: 4 };
    return { rows: 6, colsPortrait: 5, colsLandscape: 5 };
  };

  const [pageConfig, setPageConfig] = useState(getPageConfig(window.innerWidth));

  useEffect(() => {
    const handleResize = () => setPageConfig(getPageConfig(window.innerWidth));
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const PAGE_PORTRAITS = pageConfig.rows * pageConfig.colsPortrait;
  const PAGE_LANDSCAPES = pageConfig.rows * pageConfig.colsLandscape;
  const limit = PAGE_PORTRAITS + PAGE_LANDSCAPES;

  useEffect(() => {
    if (weddingInfo && weddingInfo.theme) {
      document.body.setAttribute('data-theme', weddingInfo.theme);
    } else {
      document.body.removeAttribute('data-theme');
    }
  }, [weddingInfo]);

  useEffect(() => {
    if (!code) {
      setResolving(false);
      setResolveError('Bu sayfa sadece QR ile açılır.');
      return;
    }
    let cancelled = false;
    setResolving(true);
    setWeddingId(null);
    setWeddingInfo(null);
    (async () => {
      try {
        const { wedding } = await getWeddingByCode(code);
        if (!cancelled) {
          if (wedding?._id) {
            // ✅ GÜVENLİK KONTROLÜ
            if (wedding.code !== code) {
               setResolveError('Oturum hatası. Lütfen sayfayı yenileyin.');
               return;
            }
            setWeddingId(wedding._id);
            setWeddingInfo(wedding);
          } else {
            setResolveError('Kod geçersiz veya düğün bulunamadı.');
          }
        }
      } catch {
        if (!cancelled) setResolveError('Kod çözümlenemedi (ağ/erişim).');
      } finally {
        if (!cancelled) setResolving(false);
      }
    })();
    return () => { cancelled = true; };
  }, [code]);

  const uploadedByEmail = 'misafir@example.com';

  useEffect(() => {
    if (!isOwner) {
      setPhotos([]);
      setTotalPhotos(0);
      setLoading(false);
      setSelectMode(false);
    }
  }, [isOwner]);

  useEffect(() => {
    if (!weddingId || !isOwner) return;

    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await getAllPhotos(weddingId, page, limit, activeAlbumFilter);

        if (!cancelled) {
          setPhotos(res?.photos || []);
          setTotalPhotos(res?.totalPhotos || 0);
        }
      } catch (e) {
        console.error('getAllPhotos error:', e);
        if (!cancelled) {
          setPhotos([]);
          setTotalPhotos(0);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [weddingId, page, limit, isOwner, activeAlbumFilter]);

  const handleAlbumChange = (albumName) => {
    setActiveAlbumFilter(albumName);
    setPage(1);
    setSelectedIds(new Set());
    setSelectMode(false);
  };

  const totalPages = useMemo(() => Math.max(1, Math.ceil((totalPhotos || 0) / limit)), [totalPhotos, limit]);

  useEffect(() => {
    if (page > totalPages && totalPages > 0) {
      setPage(totalPages);
    }
  }, [totalPages, page]);

  const handleDownload = async (photo) => {
    if (!isOwner) return;
    // Videolarda veya büyük dosyalarda tarayıcı belleğini şişirmemek için
    // blob yerine doğrudan backend üzerinden R2 linkine yönlendiriyoruz
    window.location.href = `${API_BASE}/api/photos/${photo._id}/download`;
  };

  const handleToggleFavorite = async (e, photo) => {
    e.stopPropagation();
    try {
      const res = await togglePhotoFavorite(photo._id);
      setPhotos(prevPhotos => prevPhotos.map(p =>
        p._id === photo._id ? { ...p, isFavorite: res.isFavorite } : p
      ));
      setActivePhoto(prev => prev && prev._id === photo._id ? { ...prev, isFavorite: res.isFavorite } : prev);

      setToastMessage(res.isFavorite ? "Fotoğraf favorilere eklendi" : "Fotoğraf favorilerden çıkarıldı");
      setTimeout(() => setToastMessage(''), 2500);
    } catch (error) {
      console.error("Favori işlemi hatası:", error);
      alert("Favori işlemi yapılamadı.");
    }
  };

  const displayedPhotos = useMemo(() => {
    let sourcePhotos = photos;

    if (showFavoritesOnly) {
      sourcePhotos = sourcePhotos.filter(p => p.isFavorite);
    }

    if (activeAlbumFilter !== 'Tümü') {
      sourcePhotos = sourcePhotos.filter(p => p.album === activeAlbumFilter);
    }

    return sourcePhotos;
  }, [photos, showFavoritesOnly, activeAlbumFilter]);

  const handleHeroImageChange = async (e) => {
    if (!isOwner) return;
    const file = e.target.files?.[0];
    if (!file) return;

    if (!window.confirm(`"${file.name}" dosyasını kapak fotoğrafı yapmak istediğinize emin misiniz?`)) {
      e.target.value = null;
      return;
    }

    try {
      setResolving(true);
      const formData = new FormData();
      formData.append('heroImage', file);

      const res = await fetch(`${API_BASE}/api/weddings/${weddingId}/hero-image`, {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`Kapak fotoğrafı yüklenemedi: ${errorText}`);
      }

      const { heroImageUrl } = await res.json();
      setWeddingInfo(prev => ({ ...prev, heroImageUrl }));
      alert('Kapak fotoğrafı başarıyla güncellendi!');

    } catch (error) {
      console.error('Kapak fotoğrafı yükleme hatası:', error);
      alert('Yükleme sırasında bir hata oluştu: ' + error.message);
    } finally {
      setResolving(false);
      e.target.value = null;
    }
  };

  const handleNewUpload = useCallback(() => {
    if (page !== 1) {
      setPage(1);
    } else {
      (async () => {
        if (!weddingId) return;
        setLoading(true);
        const res = await getAllPhotos(weddingId, 1, limit, activeAlbumFilter);
        setPhotos(res?.photos || []);
        setTotalPhotos(res?.totalPhotos || 0);
        setLoading(false);
      })();
    }
  }, [page, weddingId, limit, activeAlbumFilter]);

  const handleNextPage = useCallback(() => {
    if (page < totalPages) setPage((p) => p + 1);
  }, [page, totalPages]);

  const handlePrevPage = useCallback(() => {
    if (page > 1) setPage((p) => p - 1);
  }, [page]);

  const handleImageLoad = useCallback((id, e) => {
    const { naturalWidth: w, naturalHeight: h } = e.target;
    let kind = 'portrait';
    if (w > h + 10) kind = 'landscape';
    else if (Math.abs(w - h) <= 10) kind = 'square';
    setOrientations((prev) => ({ ...prev, [id]: kind }));
  }, []);

  const toggleSelectMode = useCallback(() => {
    if (!isOwner) return;
    setSelectMode((m) => {
      const next = !m;
      if (!next) {
        setSelectedIds(new Set());
        setSelectedMap({});
      }
      return next;
    });
  }, [isOwner]);

  const toggleSelect = useCallback((photo) => {
    if (!isOwner) return;
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(photo._id)) {
        next.delete(photo._id);
      } else {
        if (next.size >= MAX_SELECT) {
          alert(`En fazla ${MAX_SELECT} fotoğraf seçebilirsiniz.`);
          return prev;
        }
        next.add(photo._id);
      }
      return next;
    });
    setSelectedMap((prev) => {
      const next = { ...prev };
      if (next[photo._id]) {
        delete next[photo._id];
      } else {
        next[photo._id] = {
          url: photo.url,
          name: photo.originalName || photo.url?.split('/').pop()?.split('?')[0] || `${photo._id}.jpg`,
        };
      }
      return next;
    });
  }, [isOwner]);

  const clearSelection = useCallback(() => {
    setSelectedIds(new Set());
    setSelectedMap({});
  }, []);

  const handleBulkDownload = useCallback(() => {
    if (!isOwner || selectedIds.size === 0) return;
    const ids = Array.from(selectedIds).join(',');
    
    // Toplu indirmeyi tarayıcı üzerinden başlat (bellek şişmesini önler)
    window.location.href = `${API_BASE}/api/photos/download/bulk?ids=${ids}`;
    
    clearSelection();
  }, [selectedIds, isOwner, clearSelection]);

  const handleDeleteOne = useCallback(async (photo) => {
    if (!isOwner) return;
    if (window.confirm('Bu fotoğrafı silmek istiyor musunuz?')) {
      try {
        await deletePhotoById(photo._id);
        setPhotos((prev) => prev.filter((p) => p._id !== photo._id));
        setTotalPhotos((prev) => Math.max(prev - 1, 0));
        setSelectedIds((prev) => {
          const s = new Set(prev);
          s.delete(photo._id);
          return s;
        });
        setSelectedMap((prev) => {
          const { [photo._id]: _, ...rest } = prev;
          return rest;
        });
      } catch (e) {
        console.error(e);
        alert('Silme sırasında bir hata oluştu.');
      }
    }
  }, [isOwner]);

  const handleBulkDelete = useCallback(async () => {
    if (!isOwner || selectedIds.size === 0) return;
    if (window.confirm(`${selectedIds.size} fotoğrafı silmek istiyor musunuz?`)) {
      try {
        const { deletedIds = [] } = await bulkDeletePhotos(Array.from(selectedIds).slice(0, 100));
        const deletedSet = new Set(deletedIds.map(String));
        setPhotos((prev) => prev.filter((p) => !deletedSet.has(String(p._id))));
        setTotalPhotos((prev) => Math.max(prev - deletedSet.size, 0));
        clearSelection();
        setTimeout(() => {
          setPage((p) => {
            const max = Math.max(Math.ceil((totalPhotos - deletedSet.size) / limit), 1);
            return p > max ? max : p;
          });
        }, 0);
      } catch (e) {
        console.error(e);
        alert('Toplu silme sırasında bir hata oluştu.');
      }
    }
  }, [selectedIds, totalPhotos, limit, clearSelection, isOwner]);

  const handleAIEnhance = async (photo) => {
    if (!isOwner) return;
    if (code && code.startsWith('demo-')) {
      alert('İşlem Başarısız: Demo modunda yapay zeka işlem limitiniz 0 olarak kısıtlanmıştır.\n\nPremium yapay zeka özellikleri (Netleştirme ve Sanatsal Filtreler) gerçek paket satın alımlarında tam kapasite kullanılabilir durumdadır!');
      return;
    }
    try {
      setToastMessage('Yapay zeka işlemi başlatıldı...');
      await applyAIEnhance(photo._id);
      setToastMessage('İyileştirme arka planda devam ediyor.');
      setTimeout(() => setToastMessage(''), 2500);
      
      setPhotos(prev => prev.map(p => p._id === photo._id ? { ...p, aiStatus: 'pending' } : p));
      if (activePhoto && activePhoto._id === photo._id) {
        setActivePhoto(prev => ({ ...prev, aiStatus: 'pending' }));
      }
    } catch (e) {
      alert('İşlem başarısız: ' + e.message);
    }
  };

  const handleAIArtistic = async (photo, filterType) => {
    if (!isOwner) return;
    if (code && code.startsWith('demo-')) {
      alert('İşlem Başarısız: Demo modunda yapay zeka işlem limitiniz 0 olarak kısıtlanmıştır.\n\nPremium yapay zeka özellikleri (Netleştirme ve Sanatsal Filtreler) gerçek paket satın alımlarında tam kapasite kullanılabilir durumdadır!');
      return;
    }
    try {
      setToastMessage('Sanatsal filtre başlatıldı...');
      await applyAIArtisticFilter(photo._id, filterType);
      setToastMessage('Filtre işlemi arka planda devam ediyor.');
      setTimeout(() => setToastMessage(''), 2500);

      setPhotos(prev => prev.map(p => p._id === photo._id ? { ...p, aiStatus: 'pending' } : p));
      if (activePhoto && activePhoto._id === photo._id) {
        setActivePhoto(prev => ({ ...prev, aiStatus: 'pending' }));
      }
    } catch (e) {
      alert('İşlem başarısız: ' + e.message);
    }
  };

  const openLightbox = useCallback((photo) => {
    setActivePhoto(photo);
    setZoom(1);
    setOffset({ x: 0, y: 0 });
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  }, []);

  const closeLightbox = useCallback(() => {
    setLightboxOpen(false);
    setActivePhoto(null);
    setZoom(1);
    setOffset({ x: 0, y: 0 });
    document.body.style.overflow = '';
  }, []);

  // --- LIGHTBOX NAVIGATION ---
  const handleNextPhoto = useCallback((e) => {
    if (e) e.stopPropagation();
    if (!activePhoto || displayedPhotos.length <= 1) return;
    const currentIndex = displayedPhotos.findIndex(p => p._id === activePhoto._id);
    if (currentIndex === -1) return;

    // Loop: Sona geldiysek başa dön
    const nextIndex = (currentIndex + 1) % displayedPhotos.length;
    setActivePhoto(displayedPhotos[nextIndex]);
    setZoom(1);
    setOffset({ x: 0, y: 0 });
  }, [activePhoto, displayedPhotos]);

  const handlePrevPhoto = useCallback((e) => {
    if (e) e.stopPropagation();
    if (!activePhoto || displayedPhotos.length <= 1) return;
    const currentIndex = displayedPhotos.findIndex(p => p._id === activePhoto._id);
    if (currentIndex === -1) return;

    // Loop: Başa geldiysek sona dön
    const prevIndex = (currentIndex - 1 + displayedPhotos.length) % displayedPhotos.length;
    setActivePhoto(displayedPhotos[prevIndex]);
    setZoom(1);
    setOffset({ x: 0, y: 0 });
  }, [activePhoto, displayedPhotos]);

  // Keyboard Navigation
  useEffect(() => {
    if (!lightboxOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight') handleNextPhoto();
      if (e.key === 'ArrowLeft') handlePrevPhoto();
      if (e.key === 'Escape') closeLightbox();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen, handleNextPhoto, handlePrevPhoto, closeLightbox]);

  // Swipe Gestures
  const touchStartRef = useRef(null);
  const touchEndRef = useRef(null);
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    touchStartRef.current = e.targetTouches[0].clientX;
    touchEndRef.current = null;
  };

  const onTouchMove = (e) => {
    touchEndRef.current = e.targetTouches[0].clientX;
  }

  const onTouchEnd = () => {
    if (!touchStartRef.current || !touchEndRef.current) return;
    const distance = touchStartRef.current - touchEndRef.current;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) handleNextPhoto();
    if (isRightSwipe) handlePrevPhoto();
  };

  const clamp = (v, mn, mx) => Math.min(Math.max(v, mn), mx);

  const onWheelZoom = useCallback((e) => {
    e.preventDefault();
    const delta = e.deltaY < 0 ? 0.2 : -0.2;
    const next = clamp(parseFloat((zoom + delta).toFixed(2)), 1, 3);
    if (imgBoxRef.current) {
      const box = imgBoxRef.current.getBoundingClientRect();
      const halfW = (box.width * (next - 1)) / 2;
      const halfH = (box.height * (next - 1)) / 2;
      setOffset((prev) => ({
        x: clamp(prev.x, -halfW, halfW),
        y: clamp(prev.y, -halfH, halfH),
      }));
    }
    setZoom(next);
  }, [zoom]);

  const onDoubleClickToggle = useCallback((e) => {
    e.preventDefault();
    const next = zoom > 1 ? 1 : 2;
    if (imgBoxRef.current) {
      setOffset({ x: 0, y: 0 });
    }
    setZoom(next);
  }, [zoom]);

  const onMouseDown = useCallback((e) => {
    if (zoom !== 1) {
      setDragging(true);
      dragStartRef.current = { x: e.clientX - offset.x, y: e.clientY - offset.y };
    }
  }, [zoom, offset]);

  const onMouseMove = useCallback((e) => {
    if (!dragging || !imgBoxRef.current) return;
    const box = imgBoxRef.current.getBoundingClientRect();
    const nextX = e.clientX - dragStartRef.current.x;
    const nextY = e.clientY - dragStartRef.current.y;
    const halfW = (box.width * (zoom - 1)) / 2;
    const halfH = (box.height * (zoom - 1)) / 2;
    setOffset({
      x: clamp(nextX, -halfW, halfW),
      y: clamp(nextY, -halfH, halfH),
    });
  }, [dragging, zoom]);

  const onMouseUp = useCallback(() => setDragging(false), []);

  const handlePressStart = useCallback((e, photo) => {
    if (!isOwner || selectMode) return;
    const isTouchEvent = e.type === 'touchstart';
    if (!isTouchEvent && e.button !== 0) return;
    e.preventDefault();
    longPressTriggeredRef.current = false;
    e.currentTarget.classList.add('is-pressing');
    longPressTimerRef.current = setTimeout(() => {
      setSelectMode(true);
      toggleSelect(photo);
      longPressTriggeredRef.current = true;
      e.currentTarget.classList.remove('is-pressing');
      longPressTimerRef.current = null;
    }, 500);
  }, [isOwner, selectMode, toggleSelect]);

  const handlePressEnd = useCallback((e) => {
    if (longPressTimerRef.current) {
      clearTimeout(longPressTimerRef.current);
      longPressTimerRef.current = null;
    }
    if (e.currentTarget) {
      e.currentTarget.classList.remove('is-pressing');
    }
  }, []);

  if (resolving) return <div className="wedding-page">Kapak Fotoğrafı Yükleniyor…</div>;
  if (resolveError) return <div className="wedding-page">{resolveError}</div>;
  if (!weddingId) return <div className="wedding-page">Bu sayfa sadece QR ile açılır.</div>;

  return (
    <div className="wedding-page">



      {/* ✅ 1. ÜST YÖNETİM ŞERİDİ (GÜNCELLENDİ) */}
      {isOwner && (
        <div className="top-header-bar" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '12px 20px', // Biraz daha kompakt
          textAlign: 'left' // Default center'ı ezdik
        }}>
          <span style={{ fontWeight: 600, fontSize: '1.1rem' }}>
            {weddingInfo?.name || 'Düğün Galerisi Yönetimi'}
          </span>

          {/* Çıkış Yap Butonu Buraya Taşındı */}
          <button
            onClick={() => { if (window.confirm('Çıkış yapmak istediğinize emin misiniz?')) { logout(); } }}
            style={{
              background: 'rgba(255,255,255,0.2)',
              border: '1px solid rgba(255,255,255,0.4)',
              color: 'white',
              padding: '6px 12px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '0.85rem',
              fontWeight: 500,
              backdropFilter: 'blur(4px)'
            }}
          >
            Çıkış Yap
          </button>
        </div>
      )}

      {/* 2. KAPAK FOTOĞRAFI (HERO SECTION) */}
      <header className="hero-section" style={{
        backgroundImage: weddingInfo?.heroImageUrl ? `url(${weddingInfo.heroImageUrl})` : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: weddingInfo?.heroImageUrl ? 'rgba(0, 0, 0, 0.4)' : '#6a1b9a',
      }}>

        {!isOwner && (
          <h1 className="couple-names">
            {weddingInfo?.name || 'Fotoğraf Yükleme'}
          </h1>
        )}

        <p className="date">
          {isOwner
            ? 'Misafirler tarafından yüklenen tüm anıları buradan yönetebilirsiniz.'
            : (weddingInfo?.date
              ? new Date(weddingInfo.date).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })
              : 'QR ile geldiniz.'
            )
          }
        </p>

        {isOwner && (
          <div className="hero-action-bar" style={{
            position: 'absolute', top: '20px', right: '20px', left: '20px', display: 'flex', justifyContent: 'flex-start' // Sola yasla
          }}>
            {/* Sadece Kamera Butonu Kaldı */}
            <button
              onClick={() => document.getElementById('hero-image-input').click()}
              className={weddingInfo?.heroImageUrl ? "" : "upload-hero-btn"}
              style={weddingInfo?.heroImageUrl ? {
                width: '40px',
                height: '40px',
                padding: '0',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.25)',
                backdropFilter: 'blur(6px)',
                border: '1px solid rgba(255, 255, 255, 0.4)',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                cursor: 'pointer',
                color: 'white',
                transition: 'all 0.2s ease',
              } : {}}
              title={weddingInfo?.heroImageUrl ? "Kapak Fotoğrafını Değiştir" : "Kapak Fotoğrafı Yükle"}
            >
              {weddingInfo?.heroImageUrl ? <CameraIcon /> : '📷 Kapak Fotoğrafı Ekle'}
            </button>
            <input
              type="file"
              id="hero-image-input"
              style={{
                position: 'absolute',
                width: '1px',
                height: '1px',
                padding: '0',
                margin: '-1px',
                overflow: 'hidden',
                clip: 'rect(0, 0, 0, 0)',
                border: '0',
                opacity: 0,
              }}
              accept="image/*"
              onChange={handleHeroImageChange}
            />
          </div>
        )}
      </header>

      <main>
        {/* Misafir Kullanıcıya Yükleme Bölümü */}
        {!isOwner && (
          <section className="photo-section">
            <h2 className="section-title">Anılarını Paylaş</h2>
            <p>Fotoğraf ve videolarını yükle, düğün sahibi onlara galerisinden erişsin.</p>
            <UploadForm
              onUpload={handleNewUpload}
              weddingId={weddingId}
              uploadedByEmail={uploadedByEmail}
              uploadsLocked={!!weddingInfo?.uploadsLocked}
            />
          </section>
        )}

        <div style={{ textAlign: 'center', margin: '2rem 0' }}>
          <button
            onClick={() => setIsGuestbookOpen(true)}
            className="open-modal-btn"
          >
            {isOwner ? 'Anı Defterini Görüntüle' : 'Bir Mesaj Bırakın'}
          </button>
        </div>

        <Guestbook
          weddingId={weddingId}
          isOwner={isOwner}
          weddingInfo={weddingInfo}
          isOpen={isGuestbookOpen}
          onClose={() => setIsGuestbookOpen(false)}
        />

        {!isOwner && (
          <div className="notice-card">
            <p>Bu düğünün galerisi <b>sadece düğün sahibine</b> görünür. Düğün sahibiseniz <Link to="/owner/login"> giriş yapın</Link>.</p>
          </div>
        )}

        {/* ✅ ALBÜM SEÇİM KARTLARI */}
        {isOwner && weddingInfo?.albumMode !== 'default' && weddingInfo?.albumNames?.length > 0 && (
          <div className="album-nav-container">
            {/* Tümü Kartı */}
            <div
              className={`album-card ${activeAlbumFilter === 'Tümü' ? 'active' : ''}`}
              onClick={() => handleAlbumChange('Tümü')}
            >
              <img
                src={weddingInfo?.heroImageUrl || "https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"}
                alt="Tüm Fotoğraflar"
                className="album-card-bg"
              />
              <div className="album-card-overlay">
                <span className="album-card-title">Tümü</span>
              </div>
              {activeAlbumFilter === 'Tümü' && <div className="album-card-icon">✓</div>}
            </div>

            {/* Diğer Albümler */}
            {weddingInfo.albumNames.map((albumName, index) => (
              <div
                key={albumName}
                className={`album-card ${activeAlbumFilter === albumName ? 'active' : ''}`}
                onClick={() => handleAlbumChange(albumName)}
              >
                <img
                  src={weddingInfo?.heroImageUrl || `https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60`}
                  alt={albumName}
                  className="album-card-bg"
                />
                <div className="album-card-overlay">
                  <span className="album-card-title">{albumName}</span>
                </div>
                {activeAlbumFilter === albumName && <div className="album-card-icon">✓</div>}
              </div>
            ))}
          </div>
        )}

        {isOwner && (
          <section className={`gallery-section ${selectMode ? 'is-select-mode' : ''}`}>
            <div className="gallery-inner">
              <div className="gallery-header" style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '20px'
              }}>
                <h2 className="section-title" style={{ margin: 0 }}>Düğün Galerisi</h2>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <button
                    className={`filter-fav-btn ${showFavoritesOnly ? 'active' : ''}`}
                    onClick={() => setShowFavoritesOnly(!showFavoritesOnly)}
                  >
                    {showFavoritesOnly ? 'Tümünü Göster' : (
                      <>❤️ <span>Favoriler</span></>
                    )}
                  </button>

                  <button className="select-mode-btn" onClick={toggleSelectMode} aria-pressed={selectMode}>
                    {selectMode ? 'Seçimi Bitir' : 'Seç'}
                  </button>
                </div>
              </div>

              {selectMode && (
                <div className="bulk-toolbar">
                  <div className="bulk-info">
                    {selectedIds.size > 0 ? `${selectedIds.size} seçili (max ${MAX_SELECT})` : 'Fotoğraf seçmek için karttaki kutucuğu işaretleyin.'}
                  </div>
                  <div className="bulk-actions">
                    <button className="bulk-download" onClick={handleBulkDownload} disabled={selectedIds.size === 0}>
                      İndir ({selectedIds.size})
                    </button>
                    {selectedIds.size > 0 && (
                      <button className="bulk-clear" onClick={clearSelection}>Temizle</button>
                    )}
                    <button className="bulk-delete" onClick={handleBulkDelete} disabled={selectedIds.size === 0}>
                      Sil ({selectedIds.size})
                    </button>
                  </div>
                </div>
              )}

              {loading && !showFavoritesOnly ? (
                <p style={{ textAlign: 'center' }}>Fotoğraflar yükleniyor...</p>
              ) : (
                <div className="gallery-shelf">
                  {displayedPhotos.length > 0 ? (
                    displayedPhotos.map((photo) => {
                      const isSelected = selectedIds.has(photo._id);
                      const orient = orientations[photo._id] || '';
                      const isFav = !!photo.isFavorite;

                      return (
                        <div
                          key={photo._id}
                          className={`gallery-item ${orient} ${isSelected ? 'is-selected' : ''}`}
                          onMouseDown={isOwner && !selectMode ? (e) => handlePressStart(e, photo) : undefined}
                          onMouseUp={isOwner && !selectMode ? handlePressEnd : undefined}
                          onMouseLeave={isOwner && !selectMode ? handlePressEnd : undefined}
                          onTouchStart={isOwner && !selectMode ? (e) => handlePressStart(e, photo) : undefined}
                          onTouchEnd={isOwner && !selectMode ? handlePressEnd : undefined}
                        >
                          <div
                            className="image-wrapper"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (selectMode) {
                                toggleSelect(photo);
                              }
                              else if (!longPressTriggeredRef.current) {
                                openLightbox(photo);
                              }
                              longPressTriggeredRef.current = false;
                            }}
                          >
                            <button
                              className={`select-toggle ${isSelected ? 'checked' : ''}`}
                              aria-pressed={isSelected}
                              onClick={(e) => { e.stopPropagation(); toggleSelect(photo); }}
                              title={isSelected ? 'Seçimi kaldır' : 'Seç'}
                            >
                              {isSelected ? '✓' : ''}
                            </button>

                            {photo.contentType?.startsWith('video/')
                              ? (
                                <div style={{
                                  width: '100%',
                                  height: '100%',
                                  background: 'linear-gradient(135deg, #232526, #414345)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  position: 'relative'
                                }}>
                                  <div style={{
                                    width: '50px', height: '50px',
                                    borderRadius: '50%',
                                    background: 'rgba(255,255,255,0.15)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    backdropFilter: 'blur(3px)',
                                    border: '1px solid rgba(255,255,255,0.3)'
                                  }}>
                                    <PlayIcon />
                                  </div>
                                  <span style={{
                                    position: 'absolute', bottom: '6px', right: '6px',
                                    background: 'rgba(0,0,0,0.6)', color: 'white',
                                    padding: '2px 5px', borderRadius: '4px', fontSize: '9px',
                                    fontWeight: 'bold', textTransform: 'uppercase'
                                  }}>
                                    Video
                                  </span>
                                </div>
                              )
                              : photo.originalName?.toLowerCase().match(/\.(dng|cr2|nef|arw|raw|heic|heif)$/i) ? (
                                <div style={{
                                  width: '100%', height: '100%',
                                  background: 'linear-gradient(135deg, #1c1c1c, #3f3f3f)',
                                  display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                                  position: 'relative', color: '#fff'
                                }}>
                                  <div style={{ padding: '10px', background: 'rgba(255,255,255,0.1)', borderRadius: '50%', marginBottom:'5px' }}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></svg>
                                  </div>
                                  <span style={{ fontSize: '10px', fontWeight: 'bold' }}>RAW DOSYA</span>
                                </div>
                              ) : (
                                <div style={{position: 'relative', width: '100%', height: '100%'}}>
                                  <img
                                    src={photo.thumbnailUrl || getThumbnailUrl(photo.url, 400)}
                                    alt={photo.originalName || 'Düğün fotoğrafı'}
                                    loading="lazy"
                                    onLoad={(e) => handleImageLoad(photo._id, e)}
                                  />
                                  {(photo.aiStatus === 'completed' || photo.enhancedUrl || photo.artisticUrl) && (
                                    <span style={{
                                      position: 'absolute', top: '6px', right: '6px',
                                      background: 'linear-gradient(45deg, #FFD700, #FFA500)', color: '#000',
                                      padding: '2px 6px', borderRadius: '4px', fontSize: '10px',
                                      fontWeight: 'bold', boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
                                    }}>
                                      ✨ AI İşlendi
                                    </span>
                                  )}
                                  {photo.aiStatus === 'pending' && (
                                    <span style={{
                                      position: 'absolute', top: '6px', right: '6px',
                                      background: 'rgba(0,0,0,0.6)', color: '#FFD700',
                                      padding: '2px 6px', borderRadius: '4px', fontSize: '10px',
                                      fontWeight: 'bold', backdropFilter: 'blur(4px)'
                                    }}>
                                      ⏳ İşleniyor...
                                    </span>
                                  )}
                                </div>
                              )}
                          </div>

                          {photo.caption?.trim() && (
                            <div className="photo-caption" title={photo.caption}>{photo.caption}</div>
                          )}
                          <div className="photo-likes">
                            <button
                              className={`favorite-btn ${isFav ? 'active' : ''}`}
                              onClick={(e) => handleToggleFavorite(e, photo)}
                              title={isFav ? "Favorilerden çıkar" : "Favorilere ekle"}
                            >
                              <HeartIcon filled={isFav} />
                            </button>
                            <button
                              onClick={(e) => { e.stopPropagation(); handleDownload(photo); }}
                              className="download-button"
                            >
                              <DownloadIcon />
                            </button>
                            <button
                              onClick={(e) => { e.stopPropagation(); handleDeleteOne(photo); }}
                              className="delete-button"
                            >
                              <TrashIcon />
                            </button>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div style={{ padding: '40px', color: '#888', textAlign: 'center', gridColumn: '1/-1' }}>
                      {showFavoritesOnly
                        ? 'Henüz favorilere eklenmiş fotoğraf yok.'
                        : (activeAlbumFilter !== 'Tümü' ? `"${activeAlbumFilter}" albümünde henüz fotoğraf yok.` : 'Henüz fotoğraf yüklenmemiş.')
                      }
                    </div>
                  )}
                </div>
              )}

              {totalPhotos > limit && !showFavoritesOnly && (
                <div className="pagination-controls">
                  <button onClick={handlePrevPage} disabled={page === 1}>Önceki</button>
                  <span>Sayfa {page} / {totalPages}</span>
                  <button onClick={handleNextPage} disabled={page === totalPages || loading}>
                    {loading ? 'Yükleniyor...' : 'Sonraki'}
                  </button>
                </div>
              )}
            </div>
          </section>
        )}
      </main>

      {lightboxOpen && activePhoto && (
        <div className="lightbox-overlay" onClick={(e) => { if (e.target.classList.contains('lightbox-overlay')) closeLightbox(); }}>
          <div className="lightbox-content" ref={imgBoxRef}
            onWheel={(e) => { (activePhoto.contentType && !activePhoto.contentType.startsWith('video/')) && onWheelZoom(e) }}
            onDoubleClick={(e) => { (activePhoto.contentType && !activePhoto.contentType.startsWith('video/')) && onDoubleClickToggle(e) }}
          >
            <button className="lightbox-close" onClick={closeLightbox}>×</button>

            {(activePhoto.contentType && activePhoto.contentType.startsWith('video/')) ? (
              <video src={activePhoto.url} className="lightbox-media" controls autoPlay playsInline
                onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}
              />
            ) : activePhoto.originalName?.toLowerCase().match(/\.(dng|cr2|nef|arw|raw|heic|heif)$/i) ? (
              <div className="lightbox-image" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
                <div style={{ padding: '20px', background: 'rgba(255,255,255,0.1)', borderRadius: '50%', marginBottom:'15px' }}>
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></svg>
                </div>
                <h3 style={{ fontSize: '1.5rem', marginBottom: '10px' }}>RAW / Yüksek Çözünürlüklü Dosya</h3>
                <p style={{ color: '#aaa', textAlign: 'center', maxWidth: '400px' }}>
                  Bu dosya biçimi web tarayıcısında görüntülenememektedir. Görüntülemek için cihazınıza indirebilirsiniz.
                </p>
              </div>
            ) : (
              <img
                src={activePhoto.enhancedUrl || activePhoto.artisticUrl || activePhoto.url}
                alt={activePhoto.originalName || 'Fotoğraf'}
                className={`lightbox-image ${zoom > 1 ? 'is-zoomed' : ''}`}
                style={(zoom !== 1 || offset.x !== 0 || offset.y !== 0) ? { transform: `translate(${offset.x}px, ${offset.y}px) scale(${zoom})` } : undefined}
                draggable="false"
                onMouseDown={onMouseDown}
                onMouseMove={onMouseMove}
                onMouseUp={onMouseUp}
                onMouseLeave={onMouseUp}
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
              />
            )}

            {/* Navigation Arrows (Desktop) */}
            {displayedPhotos.length > 1 && (
              <>
                <button className="lightbox-nav-btn prev" onClick={handlePrevPhoto}>
                  <ChevronLeft />
                </button>
                <button className="lightbox-nav-btn next" onClick={handleNextPhoto}>
                  <ChevronRight />
                </button>
              </>
            )}

            <div className="lightbox-footer" style={{ flexDirection: 'column', gap: '10px' }}>
              {activePhoto.caption && (
                <div className="lightbox-caption" style={{ 
                  color: 'white', 
                  fontSize: '14px', 
                  textAlign: 'center',
                  background: 'rgba(0,0,0,0.5)',
                  padding: '8px 12px',
                  borderRadius: '8px',
                  maxWidth: '80%',
                  wordBreak: 'break-word'
                }}>
                  💬 {activePhoto.caption}
                </div>
              )}
              <div className="lightbox-actions" style={{ gap: '10px', display: 'flex', justifyContent: 'center' }}>
                {(!activePhoto.contentType?.startsWith('video/') && activePhoto.aiStatus !== 'pending' && !(activePhoto.enhancedUrl || activePhoto.artisticUrl)) && (
                  <>
                    <button onClick={(e) => { e.stopPropagation(); handleAIEnhance(activePhoto); }} title="Netleştir / Kaliteyi Artır" style={{fontSize: '14px', padding: '6px 12px', background: 'rgba(255,255,255,0.15)', borderRadius: '20px', border: 'none', color: 'white'}}>
                      ✨ Netleştir
                    </button>
                    <button onClick={(e) => { e.stopPropagation(); handleAIArtistic(activePhoto, 'caricature'); }} title="Karikatür Yap" style={{fontSize: '14px', padding: '6px 12px', background: 'rgba(255,255,255,0.15)', borderRadius: '20px', border: 'none', color: 'white'}}>
                      🎨 Karikatür
                    </button>
                  </>
                )}
                {activePhoto.aiStatus === 'pending' && (
                  <span style={{color: '#ffeb3b', fontSize: '14px', padding: '0 8px'}}>⏳ İşleniyor...</span>
                )}
                
                <button
                  className={`favorite-btn ${activePhoto.isFavorite ? 'active' : ''}`}
                  onClick={(e) => { e.stopPropagation(); handleToggleFavorite(e, activePhoto); }}
                >
                  <HeartIcon filled={activePhoto.isFavorite} />
                </button>
                <button onClick={(e) => { e.stopPropagation(); handleDownload(activePhoto); }}>
                  <DownloadIcon />
                </button>
                <button onClick={(e) => { e.stopPropagation(); handleDeleteOne(activePhoto); closeLightbox(); }}>
                  <TrashIcon />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {toastMessage && (
        <div className="toast-notification">
          {toastMessage}
        </div>
      )}
    </div>
  );
}